import { Component } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap';
import 'normalize.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './css/geral.css';
import Routes from './Routes';

import { Provider } from 'react-redux';
import store from './store';

export default class App extends Component {

  render() {

    // Para homologação: REACT_APP_PUBLIC_URL=/homologacao/
    // Para produção: REACT_APP_PUBLIC_URL=https://www.secuidae.com.br/

    const publicUrl = process.env.REACT_APP_PUBLIC_URL || '/';
    // Se começa com /, é um caminho relativo (homologação)
    // Se começa com http, é URL completa (produção)
    let basename = '/';
    if (publicUrl.startsWith('/') && publicUrl !== '/') {
      basename = publicUrl.replace(/\/$/, ''); // Remove a barra final
    }
    /*
    console.log('App render');
    console.log('REACT_APP_PUBLIC_URL:', process.env.REACT_APP_PUBLIC_URL);
    console.log('basename calculado:', basename);
    */
    return (
      <Provider store={store}>
        <div className="App">
          <Router basename={basename}>
            <ScrollToTop />
            <Routes />
          </Router>
        </div>
      </Provider>
    );
  }
}
